const ContentTarget = {
    ALL: 'all',
    SECOND_DAY_PARTICIPANTS: 'second_day',
    ACCOMMODATION_PARTICIPANT: 'accommodation'
};

export default ContentTarget;
